import { Upload } from "antd";
import styled from "styled-components";

export const StyledImageUpload = styled(Upload)`
    .ant-upload {
        width: 100%;
    }
    .ant-upload-list-picture-card-container {
        width: 150px;
        height: 150px;
    }
    .ant-upload-select-picture-card {
        width: 150px;
        height: 150px; 
    }
`